module.exports = __webpack_public_path__ + "documents/3434e55a1628b0cb7d66108e8e6a2349.pdf";